import { useEffect } from 'react';
import { PUSH_PATHS } from '../turboLive/push/paths';
import { subscribePath, unsubscribePath } from '../turboLive/push/pushSubscriptions';
import { dispatch, useReframe } from 'nike-re-framejs';
import {
    betInfoPush,
    betInfoSnapshot,
    fetch10NajLive,
    loadMatches,
    matchInfoPush,
    matchInfoSnapshot
} from './handlers';
import { useInterval } from '../../common/hooks/useInterval';
import { getMatchIds } from './components/HomepageTop5';
import { TOP10_LIVE_TAB } from './constants';

export function useTop10LivePush(matchId: string, betId: string, startSub: boolean): void {
    matchId = matchId.toString();
    betId = betId.toString();

    useEffect(() => {
        if (!startSub) {
            return () => {};
        }
        const scoreboard_path = PUSH_PATHS.matchScoreboard(matchId);
        const bet_path = PUSH_PATHS.betInfo(betId);

        if (matchId) {
            subscribePath(scoreboard_path, {
                onSnapshot: data => {
                    dispatch(matchInfoSnapshot(data, matchId));
                },
                onMessage: data => dispatch(matchInfoPush(data, matchId))
            });
            subscribePath(bet_path, {
                onSnapshot: data => dispatch(betInfoSnapshot(data, betId)),
                onMessage: data => dispatch(betInfoPush(data, betId))
            });
        }
        return () => {
            unsubscribePath(scoreboard_path);
            unsubscribePath(bet_path);
        };
    }, [matchId, betId, startSub]);
}

// periodically fetch live top ranking selections
export function useFetchTopLive(activeTab: string) {
    useInterval(
        () => {
            fetch10NajLive();
        },
        activeTab === TOP10_LIVE_TAB ? [60 * 1000] : null
    );
}

// fetch additional info for top events (top10/top10live/betbook top 20) matches from N1 boxes, necessesary for stream icons
export function useFetchMatchesFromTopEvents(dispatchFunc: Function, topEventsSub: Function, matchesSub: Function) {
    const { derefSub } = useReframe();
    const areMatchesLoaded = derefSub(matchesSub);
    const topEvents = derefSub(topEventsSub);
    if (topEvents?.length === 0 || areMatchesLoaded) return;
    const matchIds = getMatchIds(topEvents);
    if (matchIds && matchIds.size > 0) {
        loadMatches(matchIds, dispatchFunc);
    }
}
